export default __webpack_public_path__ + "static/media/greg.4547a7e4.jpg";